import { useFormContext } from "react-hook-form";
import moment from "moment";
import { Box, Typography } from "@material-ui/core";
import { Color, DatePickerController, SelectMenu } from "@bonliva-crm/ui";
import locale, { dateFormat } from "@bonliva-crm/locale";
import { FilterWithFavouriteProps } from "../utils/filters-record-types";
import { CollapsibleFavFilter } from "./_base/collapsible-fav-filter";

export function NextContactFilter(props: FilterWithFavouriteProps) {
  const { watch, setValue } = useFormContext();
  const title = props.label ?? locale.NextContact;
  const from = watch(`${props.name}.from`);
  const to = watch(`${props.name}.to`);

  const clear = () => {
    setValue(`${props.name}.from`, null);
    setValue(`${props.name}.to`, null);
  };

  const hasValue = Boolean(from || to);

  const fromPicker = () => (
    <DatePickerController
      name={`${props.name}.from`}
      DatePickerProps={{
        fullWidth: true,
        isClearable: true,
        label: locale.StartDate
      }}
    />
  );

  const toPicker = () => (
    <DatePickerController
      name={`${props.name}.to`}
      DatePickerProps={{
        fullWidth: true,
        isClearable: true,
        label: locale.EndDate
      }}
    />
  );

  // slider view
  if (props.setFavorite) {
    return (
      <CollapsibleFavFilter
        title={title}
        favorite={props.favorite}
        onSetFavorite={props.setFavorite}
        isClearable={hasValue}
        onClear={clear}
        isDirty={hasValue}
        initialExpanded={hasValue}
      >
        <Box display="flex" flex="1">
          <Box flex="0 0 45%">{fromPicker()}</Box>
          <Box flex="0 0 45%" pl={1}>
            {toPicker()}
          </Box>
        </Box>
      </CollapsibleFavFilter>
    );
  }

  return (
    <SelectMenu
      badgeLabel={getBadge(from, to)}
      placeholder={
        <Typography
          variant="body1"
          style={{ color: Color.DetailsInput, lineHeight: "calc(1rem + 4px)" }}
        >
          {title}
        </Typography>
      }
      openByDefault={false}
      showPlaceholderOnExpand={true}
      isClearable={hasValue}
      onClear={clear}
      content={
        <Box flex="1">
          <Box style={{ marginTop: 16, display: "flex" }}>
            <Box style={{ flex: "0 0 45%" }}>{fromPicker()}</Box>
            <Box style={{ flex: "0 0 45%", paddingLeft: "8px" }}>{toPicker()}</Box>
          </Box>
        </Box>
      }
    />
  );
}

function getBadge(from: Date | null, to: Date | null) {
  if (from && !to) {
    return "Fram " + moment(from).format(dateFormat) + " ";
  }

  if (!from && to) {
    return "Til " + moment(to).format(dateFormat) + " ";
  }

  if (from && to) {
    return moment(from).format(dateFormat) + " – " + moment(to).format(dateFormat);
  }

  return "";
}
